import { Link } from "react-router-dom";
import type { IntegrationStatus, PmsType } from "@/types";

interface Props {
  pmsType: PmsType;
  status: IntegrationStatus | null;
}

const PMS_LABELS: Record<string, { label: string; path: string }> = {
  ezyvet: { label: "ezyVet", path: "/settings/integrations/ezyvet" },
  cornerstone: { label: "Cornerstone", path: "/settings/integrations/cornerstone" },
};

/**
 * Shown on every page when an integrated clinic's connection is failing,
 * so audits don't silently go stale.
 */
export function IntegrationBanner({ pmsType, status }: Props) {
  const info = PMS_LABELS[pmsType];
  if (!info || status !== "error") return null;
  return (
    <div className="banner warning" role="alert">
      <span>{info.label} isn't connecting, so new consults aren't being audited.</span>
      <Link to={info.path} className="btn btn-sm">
        Reconnect {info.label}
      </Link>
    </div>
  );
}
